import React from "react"
import PropTypes from "prop-types"
import enhanceWithClickOutside from "react-click-outside"
import DatePicker from 'react-datepicker';

class ChangeDateCalendar extends React.Component {
  handleClickOutside() {
    if (this.props.isActive) this.props.onCancel()
  }

  render() {
    const {isActive, onChangeDate, onConfirm, onShowCalendar, selectedDate} = this.props
    return (
      <div className="change-transaction-date">
        <button className="change-transaction-date__button" type="button" onClick={onShowCalendar} />
        {isActive &&
          <div className="change-transaction-date__calendar">
            <h5>Change Transaction Date</h5>
            <DatePicker inline selected={selectedDate} onChange={onChangeDate} />
            <footer>
              <button className="change-transaction-date__confirm" type="button" onClick={onConfirm}>
                Confirm
              </button>
            </footer>
          </div>
        }
      </div>
    )
  }
}

ChangeDateCalendar.propTypes = {
  isActive: PropTypes.bool,
  onCancel: PropTypes.func,
  onChangeDate: PropTypes.func,
  onConfirm: PropTypes.func,
  onShowCalendar: PropTypes.func,
  selectedDate: PropTypes.object
}

export default enhanceWithClickOutside(ChangeDateCalendar)
